// Phase 36 Batch AS — PostHog event helpers for the new homepage.
// All wrapped in try/catch so blocked / unloaded PostHog never breaks
// the marketing surface.

function _capture(name, props = {}) {
  try {
    if (typeof window === "undefined") return;
    window.posthog?.capture?.(name, props);
  } catch {
    /* PostHog blocked — ignore */
  }
}

export function trackLandingV2Viewed() {
  _capture("landing_v2_viewed", {});
}

export function trackLandingCtaClicked({ cta_name, section }) {
  _capture("landing_cta_clicked", { cta_name, section });
}

export function trackWaitlistSignup({ plan }) {
  _capture("waitlist_signup", { plan });
}

// Batch AT — fired in addition to `waitlist_signup` when a referral
// code was captured from the URL. Kept as a separate event so that
// the PostHog funnel can attribute pull-through without re-parsing
// every signup row.
export function trackWaitlistSignupWithReferral({ plan, referral_source }) {
  _capture("waitlist_signup_with_referral", { plan, referral_source });
}

export function trackPricingCardHovered({ plan }) {
  _capture("pricing_card_hovered", { plan });
}

// ─── Phase 37 Batch AU — Viral referral loop events ────────────────────
//
// `waitlist_signup_success` — fired once the success screen mounts
// (i.e. POST resolved 200). Distinct from `waitlist_signup` (which
// fires on submit, before we know the row was persisted) so the
// funnel chart shows submit → confirmed without inflating numbers
// when the network round-trips fail.
export function trackWaitlistSignupSuccess({ plan, referral_code }) {
  _capture("waitlist_signup_success", { plan, referral_code });
}

export function trackReferralLinkCopied({ referral_code }) {
  _capture("referral_link_copied", { referral_code });
}

export function trackReferralShareClicked({ channel, referral_code }) {
  _capture("referral_share_clicked", { channel, referral_code });
}

// Fired ONCE, the first time the referrer's count crosses the
// `target` (3). The success-screen component dedupes via a ref so
// repeated polls don't re-fire the event.
export function trackReferralGoalUnlocked({ referral_code, referred_count }) {
  _capture("referral_goal_unlocked", { referral_code, referred_count });
}

// ─── Batch BC — Dashboard "Refer Friends" widget events ────────────────
//
// Mirrors the three landing-side events above, but emitted from the
// authenticated dashboard surface (`components/dashboard/ReferFriendsWidget`).
// Kept as distinct event names so the PostHog funnel can attribute
// referral pull-through per acquisition surface — a copy from the
// dashboard signals an existing user is championing the product (lower
// CAC ceiling) vs. a copy from the post-signup screen (higher intent,
// brand-new lead).
export function trackDashboardReferralLinkCopied({ referral_code }) {
  _capture("dashboard_referral_link_copied", { referral_code });
}

export function trackDashboardReferralShareClicked({ channel, referral_code }) {
  _capture("dashboard_referral_share_clicked", { channel, referral_code });
}

export function trackDashboardReferralGoalUnlocked({ referral_code, referred_count }) {
  _capture("dashboard_referral_goal_unlocked", { referral_code, referred_count });
}
